import { render, staticRenderFns } from "./CmgMealNonBuilder.vue?vue&type=template&id=367b2c8c&scoped=true&lang=pug"
import script from "./cmg-meal-non-builder.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-non-builder.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMealNonBuilder.vue?vue&type=style&index=0&id=367b2c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367b2c8c",
  null
  
)

export default component.exports